/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { DateTime } from 'luxon'
import { FormattedMessage } from 'react-intl'
import { Badge, BadgeProps } from '@mantine/core'

export type TransactionStatusBadgeProps = BadgeProps & {
  transaction: Partial<Transaction>
}

function TransactionStatusBadge (props: TransactionStatusBadgeProps) {
  const { transaction, ...others } = props

  if (transaction.paid || transaction.paidAt) {
    return (
      <Badge color="green" {...others}>
        <FormattedMessage
          id="paid"
          defaultMessage="Payé"
        />
      </Badge>
    )
  }
  if (DateTime.fromISO(transaction.dueAt).toJSDate() >= new Date()) {
    return (
      <Badge color="yellow" {...others}>
        <FormattedMessage
          id="pending"
          defaultMessage="En attente"
        />
      </Badge>
    )
  }
  return (
    <Badge color="red" {...others}>
      <FormattedMessage
        id="unpaid"
        defaultMessage="Impayé"
      />
    </Badge>
  )
}

export default TransactionStatusBadge
